import { getHttpClient } from '../../../../shared/utils/http-client.ts';
import { Document } from '../models/document';
import { deleteDocumentEndpoint } from './const';

export const deleteDocument = (document: Document) => {
    document.isDeleted = true;
    return getHttpClient().post({ url: deleteDocumentEndpoint, data: JSON.stringify(document) });
};
